import parse from 'html-react-parser'
import replaceShortCodes from './replace-shortcodes'
import replace from './replace'

const parseHtml = html => {

  const parsed = parse(
    replaceShortCodes(html || ''),
    {
      replace: replace
    }
  )

  return parsed
}


export default parseHtml
